<!-- NAVBAR -->
 <!--https://materialui.co/icons-->
<div #sidenavContainer>
  <mat-toolbar>
    <button mat-icon-button (click)="this.isExpanded = !this.isExpanded">
      <mat-icon>menu</mat-icon>
    </button>
    <a
      class="navbar-brand titulo"
      style="color: white"
      [routerLink]="['/page/home']"
      ><img src="/assets/img/logo-empresa.png" alt="logo" />
      <b> Grupo Gestoria Pastor</b></a
    >
    <span class="example-spacer"></span>
  </mat-toolbar>
  <mat-sidenav-container
    class="example-container"
    (backdropClick)="this.isExpanded = !this.isExpanded"
    autosize
  >
    <mat-sidenav
      #sidenav
      class="example-sidenav"
      mode="over"
      opened="true"
      *ngIf="isExpanded"
    >
      <mat-nav-list>
        <mat-list-item [routerLink]="['/page/home']" (click)="toGo()" *ngIf="rol != 'ROLE_SUPERADMIN'">
          <span class="full-width">Inicio</span>
          <mat-icon mat-list-icon>home</mat-icon>
        </mat-list-item>

        <mat-list-item [routerLink]="['/page/solicitudes']" (click)="toGo()" *ngIf="rol != 'ROLE_SUPERADMIN'">
          <span class="full-width">Solicitudes</span>
          <mat-icon mat-list-icon>format_list_numbered</mat-icon>
        </mat-list-item>

        <mat-list-item [routerLink]="['/page/expedientes']" (click)="toGo()" *ngIf="rol != 'ROLE_SUPERADMIN'">
          <span class="full-width">Expedientes</span>
          <mat-icon mat-list-icon>fact_check</mat-icon>
        </mat-list-item>

        <mat-list-item (click)="toGoMatriculacion()" *ngIf="!hide">
          <mat-icon mat-list-icon>directions_car_filled</mat-icon>
          Matriculación
        </mat-list-item>

        <mat-list-item (click)="toGoCambio()" *ngIf="!hide">
          <mat-icon mat-list-icon>multiple_stop</mat-icon>
          Cambio de Propiedad
        </mat-list-item>

        <mat-list-item (click)="toGoJustificante()" *ngIf="!hide || rol === 'VENTAS'">
          <mat-icon mat-list-icon>wysiwyg</mat-icon>
          Justificante
        </mat-list-item>

        <mat-list-item (click)="toGoDistintivo()" *ngIf="!hide">
          <mat-icon mat-list-icon>class</mat-icon>
          Distintivo
        </mat-list-item>

        <mat-list-item (click)="toGoInforme()" *ngIf="!hide || rol === 'VENTAS'">
          <mat-icon mat-list-icon>speaker_notes</mat-icon>
          Informe
        </mat-list-item>

        <mat-list-item (click)="toGoReduccion()" *ngIf="!hide">
          <mat-icon mat-list-icon>assignment_returned</mat-icon>
          Doble Transferencia
        </mat-list-item>

        <mat-list-item (click)="toGoBajas()" *ngIf="!hide">
          <mat-icon mat-list-icon>thumb_down</mat-icon>
          Bajas
        </mat-list-item>

        <mat-list-item (click)="toGoFirmaDocumentos()" *ngIf="!hide || rol === 'VENTAS'">
          <mat-icon mat-list-icon>draw</mat-icon>
          Firma de Documentos
        </mat-list-item>

        <mat-list-item [routerLink]="['/page/gestion']" (click)="toGo()" *ngIf="rol === 'ROLE_SUPERADMIN'">
          <mat-icon mat-list-icon>people</mat-icon>
          Gestion de usuarios
        </mat-list-item>
        <!--<mat-list-item [routerLink]="['/page/ayudas']" (click)="toGoAyudas()" *ngIf="!hide">
          <span>Ayudas</span>
        <mat-icon mat-list-icon>electrical_services</mat-icon>
        </mat-list-item>-->
        <mat-list-item (click)="toGoContactos()" *ngIf="!hide">
          <span>Contactos</span>
          <mat-icon mat-list-icon>contacts</mat-icon>
        </mat-list-item>

        <mat-list-item [routerLink]="['/page/nosotros']" (click)="toGo()" *ngIf="!hide">
          <span>Directorio</span>
          <!--<mat-icon mat-list-icon>chat_bubble</mat-icon>-->
          <mat-icon mat-list-icon>quick_contacts_dialer</mat-icon>
        </mat-list-item>

        <mat-list-item [routerLink]="['/page/cuenta']" (click)="toGo()" *ngIf="rol != 'ROLE_SUPERADMIN'">
          <span>Mi cuenta</span>
          <mat-icon mat-list-icon>account_circle</mat-icon>
        </mat-list-item>

        <mat-list-item (click)="logout()">
          <span>Salir</span>
          <mat-icon mat-list-icon>exit_to_app</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>
    <div class="container-fluid p-2 div-padre">
      <!-- BODY -->
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-container>
</div>

<!-- FOOTER -->
<app-footer></app-footer>
<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" src="/assets/img/logo-empresa.png" alt="" />
</div>
